<template>
  <div style="padding:14px 10px">
    <div class="cur_route">{{ $route.name }}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="conts fcl">
      <div class="frw fac">
        <div class="nav_item frw fac " :class="{ nav_item_s: i == nav_index }" v-for="(item, i) in navs" :key="i"
          @click="navChange(i)">{{ item }}
        </div>
      </div>
      <div class="div_cont box-sizing">
        <withdrawalRecords v-if="nav_index == 0" />
        <lockCardList v-if="nav_index == 1" />
        <exchangeRateDiff v-if="nav_index == 2" />
        <internalRecharge v-if="nav_index == 3" />
      </div>
    </div>

  </div>
</template>
<script>
import withdrawalRecords from './withdrawal_records.vue'
import lockCardList from './lock_card_list.vue'
import exchangeRateDiff from './exchange_rate_diff.vue'
import internalRecharge from './internal_recharge.vue'
export default {
  components: {
    withdrawalRecords,
    lockCardList,
    exchangeRateDiff,
    internalRecharge,
  },
  data() {
    return {
      navs: ['Withdrawal Records', 'Lock Card', 'Recharge Rate Diff', 'Internal Recharge'],
      nav_index: 0
    }
  },
  methods: {
    navChange(i) {
      this.nav_index = i
    }
  }
}

</script>
<style scoped>
.conts {
  margin-top: 20px;
}

.nav_item {
  height: 50px;
  padding: 0 22px;
  background: rgba(0, 184, 194, .05);
  border-radius: 16px 16px 0 0;
  color: rgba(11, 50, 117, .7);
  font-size: 14px;
  margin-right: 1px;
  border: 1px solid #fff;
  cursor: pointer;
  white-space: nowrap;
}

.nav_item_s {
  color: #00b8c2;
  background: #fff;
  box-shadow: 5px 0 10px rgba(3, 97, 240, .12);
}
</style>



// WEBPACK FOOTER //
// src/views/business_settlement/business_settlement.vue